import { GridColDef, GridRowParams } from "@mui/x-data-grid";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { OverflowTooltip, Table } from "@4uhub/lib4uhub";
import MainApi from "../../../../../../services/mainApi.service";
import { useCallback, useMemo, useState } from "react";
import { ITicketAutomationReceivedMessagePrivateInsurance } from "../../../../../../models/ticket-automation-received-message-private-insurance";
import PrivateInsurance from "./PrivateInsuranceForm/PrivateInsurance";

const TICKET_AUTOMATION_RECEIVED_RULES_ROUTE =
  process.env.REACT_APP_AUTOMATIONS +
  "/api/v1/TicketAutomationReceivedMessagePrivateInsurance/";
const ticketAutomationReceivedMessagePrivateInsuranceService =
  new MainApi<ITicketAutomationReceivedMessagePrivateInsurance>(
    TICKET_AUTOMATION_RECEIVED_RULES_ROUTE,
  );

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedMessagePrivateInsurance.";

const PrivateInsurancePage = () => {
  const { t } = useTranslation();

  const { id: ticketAutomationReceivedRuleId } = useParams();

  const [timeRuleForm, setTimeRuleForm] = useState(false);

  const [selectedId, setSelectedId] = useState<string>();

  const columns: GridColDef<ITicketAutomationReceivedMessagePrivateInsurance>[] =
    [
      {
        field: "externalId",
        headerName:
          t(translationPath + "external_private_id") ||
          "External Private Insurance ID",
      },
      {
        field: "externalName",
        headerName:
          t(translationPath + "external_private_name") ||
          "External Private Insurance Name",
        renderCell: (params) =>
          params.value ? (
            <OverflowTooltip
              text={params.value}
              tooltip={params.value}
              textTransform="none"
              variant="body2"
            />
          ) : (
            "-"
          ),
      },
    ];

  const handleAdd = () => {
    setTimeRuleForm(true);
  };

  const handleRowClick = (
    params: GridRowParams<ITicketAutomationReceivedMessagePrivateInsurance>,
  ) => {
    if (!params.row) return;
    setTimeRuleForm(true);
    setSelectedId(params.row.id);
  };

  const handleBack = useCallback(() => {
    setSelectedId(undefined);
    setTimeRuleForm(false);
  }, []);

  const props = useMemo(() => {
    return {
      TicketAutomationReceivedRuleId: ticketAutomationReceivedRuleId,
    };
  }, [ticketAutomationReceivedRuleId]);

  return (
    <Box sx={{ height: 600, width: "100%" }}>
      {timeRuleForm && (
        <Box
          sx={(t) => ({
            p: 1,
            px: 10,
            width: "100%",
            height: "100%",
            overflow: "auto",
            backgroundColor: t.palette.background.default,
            borderRadius: 1,
          })}
        >
          <PrivateInsurance
            id={selectedId}
            ticketAutomationReceivedRuleId={ticketAutomationReceivedRuleId}
            onBackButton={handleBack}
          />
        </Box>
      )}
      {!timeRuleForm && (
        <Box height={600}>
          <Table<ITicketAutomationReceivedMessagePrivateInsurance>
            showDefaultMacroFilters={false}
            service={ticketAutomationReceivedMessagePrivateInsuranceService}
            columns={columns}
            title={""}
            searchInput
            onAdd={handleAdd}
            onRowClick={handleRowClick}
            searchInputAutoFocus={false}
            defaultPageSize={20}
            serviceProps={props}
            pageSizeOptions={[5, 10, 20]}
            searchInputPlaceHolder={""}
            addButtonLabel={
              t(translationPath + "add_private_insurance") ||
              "Add Automation Tasy Orientation"
            }
            confirmOptions={{
              title: t(translationPath + "confirm.title"),
              description: t(translationPath + "confirm.description"),
              confirmationButtonProps: {
                variant: "contained",
              },
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default PrivateInsurancePage;
